import FormTooltip from './form-tooltip';

export default FormTooltip;
